import { useEffect } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import {
  FcServices,
  FcSignature,
  FcEditImage,
  FcApproval,
  FcRules,
} from "react-icons/fc";
import { MdLiveHelp } from "react-icons/md";
const MOAMADIOT_LINK = process.env.REACT_APP_URL + "moamadoiot";
function Home() {
  useEffect(() => {
    document.body.classList.add("accountBodyColor");

    // Clean up function to remove the class when the component unmounts
    return () => {
      document.body.classList.remove("accountBodyColor");
    };
  }, []);
  return (
    <div className="home-page">
      <div className="first-part">
        <p style={{ textAlign: "center" }} className="App-logo-spin">
          <img src="logo.jpg" alt="City logo" style={{ width: "80px" }} />
        </p>
        <div style={{ padding: "10px" }}>
          <div style={{ textAlign: "center" }}>
            <b> بلدية ام الفحم</b>{" "}
          </div>
          <br /> تضع بين يديك هذا النظام من أجل تسهيل وإتاحة خدمة التقدم
          لمناقصات الوظائف للجميع. <br />
          وذلك من خلال إختيار "מועמדויות" من القائمة الرئيسية "תפריט".
          <br />
        </div>
        <div className="responsive-div">
          <span style={{ color: "rgb(184, 49, 47)" }}>
            <FcRules />
            العملية بسيطة وتحتاج الى تسجيل مسبق.
            <br /> <FcApproval />
            إذا قام المستخدم بالتقدم لمناقصة في النظام القديم فلا يجب عليه
            التسجيل, وما عليه سوى إعادة تعيين كلمة المرور "איפוס סיסמה".
          </span>
          <div className="text-center" style={{ color: "red" }}>
            <Link to="/moamadoiot" style={{ color: "red" }}>
              التقدم لمناقصة
            </Link>
          </div>
        </div>

        <ol
          style={{
            listStyleType: "none",
            paddingInlineStart: "10",
          }}
        >
          <li style={{ marginBottom: "10px" }}>
            <FcServices />
            تستطيع نقل تفاصيلك من اخر مناقصة تقدمت لها سابقا وتعديل ما يلزم .
          </li>
          <li style={{ marginBottom: "10px" }}>
            <FcSignature /> لا يمكن قبول ترشحك بدون توقيعها عن طريق "חתימה
            ושיגור"
          </li>
          <li>
            <FcEditImage />
            تستطيع تعديل ترشحك طالما لم ينتهي موعد التقدم ولم تقم بالتوقيع
          </li>
        </ol>
      </div>
      <div className="second-part">
        <div className="columns-container">
          <Col>
            <p style={{ padding: "10px" }} className="centered-text">
              تفاصيل التواصل مع قسم المناقصات:
              <br />
              هاتف: 8285736-04
              <br />
              mas@uefmail.com <br />
            </p>
          </Col>
          <Col>
            <p style={{ padding: "10px" }}>
              <span style={{ color: "rgb(184, 49, 47)", fontWeight: "bold" }}>
                نتمنى لك التوفيق
              </span>
            </p>
          </Col>
          <Col>
            <p style={{ padding: "10px", color: "red", fontWeight: "bold" }}>
              <span className="blinking-text">
                تقع المسؤولية الكاملة لتوقيع وارسال الترشح قبل تاريخ انتهاء
                المناقصة على المتقدم.
              </span>
            </p>
          </Col>
        </div>
        <div className="columns-container">
          <Col>
            <p className="centered-text">
              העזרה שמופיעה בכל מרכיבי המערכת, היא בהתאם לתקנות העיריות, ע"י
              לחיצה על האייקון <br />
              <span className="help">
                <MdLiveHelp />
              </span>{" "}
            </p>
          </Col>
          <Col>
            <p
              style={{ padding: "10px", width: "100%" }}
              className="centered-text"
            >
              <span style={{ color: "rgb(184, 49, 47)" }}>
                תקנות העיריות (מכרזים לקבלת עובדים ברשויות המקומיות), תש"ם-1979.
                <br />
                <a
                  href="https://www.nevo.co.il/law_html/law01/p182_048.htm"
                  target="blank"
                  style={{ color: "red" }}
                >
                  אתר nevo.co.il
                </a>
              </span>
            </p>
          </Col>
          <Col>
            <p className="centered-text">
              במקרה שנתקלת בבעיה כלשהיא, אתה מוזמן להתקשר דרך פרטי הקשר שמופיעים
              כאן.
            </p>
          </Col>
        </div>
      </div>
      <p style={{ textAlign: "center", color: "white", fontSize: "20px" }}>
        כל הזכויות שמורות לחברת מאאר דיגיטל
        <br></br>{" "}
        <img src="maarlogo.png" alt="maar logo" style={{ width: "100px" }} />
        <br />
        טלפון: 050-000000000
        <br />
        aaa@aaa.com
      </p>
    </div>
  );
}

export default Home;
